import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import { palette } from '../../../styles/colors'

interface NewBadgeProps {
    styleOverrides?: CSSProperties
}

const newBadgeStyles = css({
    color: palette.orangeMFC,
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    padding: '1px 3px',
    display: 'flex',
})

const NewBadge = memo((props: NewBadgeProps) => {
    const { styleOverrides = {} } = props

    return (
        <div
            data-testid="Badge__NewModel"
            css={newBadgeStyles}
            style={styleOverrides}
        >
            NEW
        </div>
    )
})

export default NewBadge
export { NewBadge }
